


import { useEffect, useRef } from 'react';
import { 
  Button,
  styled
} from '@mui/material';

const GlowButton = styled(Button)(({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    padding: '14px 24px',
    backgroundColor: '#07329F',
    color: 'white',
    fontWeight: 400,
    borderRadius:'12px',
    fontSize:'14px',
    '&:hover': {
      backgroundColor: '#07329F70',
    },
    fontFamily: 'Poppins, sans-serif',
    '& .glow': {
      height: 150,
      width: 150,
      background: 'radial-gradient(circle closest-side, rgba(255, 255, 255, 0.23), transparent)',
      position: 'absolute',
      borderRadius: '50%',
      zIndex: 2,
      top: -75,
      left: -75,
      opacity: 0,
      transition: 'opacity 300ms ease',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
}));


// Custom Button Component with Glow Effect
const CustomGlowButton = ({ text, fw, onClick,istransform = false, ...props }) => {
    const buttonRef = useRef(null);
    const glowRef = useRef(null);
  
    useEffect(() => {
      const button = buttonRef.current;
      const glow = glowRef.current;
  
      const handleMouseMove = (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        if (glow) {
          glow.style.transform = `translate(${x}px, ${y}px)`;
          glow.style.opacity = '1';
        }
      };
  
      const handleMouseLeave = () => {
        if (glow) {
          glow.style.opacity = '0';
        }
      };
  
      if (button) {
        button.addEventListener('mousemove', handleMouseMove);
        button.addEventListener('mouseleave', handleMouseLeave);
      }
  
      return () => {
        if (button) {
          button.removeEventListener('mousemove', handleMouseMove);
          button.removeEventListener('mouseleave', handleMouseLeave);
        }
      };
    }, []);
  
    return (
      <GlowButton ref={buttonRef} onClick={onClick} {...props} sx={{ width: fw === 1 ? '100%' : 'auto' , textTransform:  istransform  && "none !important",  }}>
        {text}
        <div ref={glowRef} className="glow" />
      </GlowButton>
    );
  };

  export default CustomGlowButton;